module.exports = __webpack_public_path__ + "img/SOUTHASIA_LEGUMES.a89ef90c.png";